<template>
  <tr v-if="$parent.$parent.$parent.rerender">
    <td
      v-bind:class="{
        'has-error': $parent.hasBankGuarantError(index, 'UF_BANK_NAME')
      }"
    >
      <input type="hidden" v-model="item.ID" />
      <input
        class="i-main-style "
        style="width: 530px"
        type="text"
        v-model="item.UF_BANK_NAME"
        :disabled="$parent.$parent.$parent.projectDisabled"
        @keyup="$parent.removeBankGuarantError(index, 'UF_BANK_NAME')"
      />
      <div class="error-text">
        {{ $parent.bankGuarantErrorText(index, "UF_BANK_NAME") }}
      </div>
    </td>
    <td
      v-bind:class="{
        'has-error': $parent.hasBankGuarantError(index, 'UF_OBJEM_VALUE')
      }"
    >
      <input
        class="i-main-style i-co-executor-style"
        type="text"
        v-model="item.UF_OBJEM_VALUE"
        v-on:keypress="$parent.$parent.isNumber($event)"
        :disabled="$parent.$parent.$parent.projectDisabled"
        @keyup="$parent.removeBankGuarantError(index, 'UF_OBJEM_VALUE')"
      />
      <div class="error-text">
        {{ $parent.bankGuarantErrorText(index, "UF_OBJEM_VALUE") }}
      </div>
    </td>
    <td>
      <a
        v-show="!$parent.$parent.$parent.projectDisabled"
        v-on:click="$parent.deleteItem(index)"
        class="link-delete-row"
      ></a>
    </td>
  </tr>
</template>

<script>
export default {
  props: ["item", "index"],
  name: "bank_guarantee_list"
};
</script>

<style scoped></style>
